import clsx from "clsx";
import { useJobListForAssignee } from "~/features/common/hooks/useJobListForAssignee";
import { useWhoAmIQuery } from "~/generated/graphql";

// Rendered only for the "Jobs" entry, so the sidebar holds a single set of job subscriptions
// instead of one per sidebar item (each of which ran its own handlers on every job update).
export const OpenJobsBadge = ({ collapsed }: { collapsed: boolean }) => {
  const meQuery = useWhoAmIQuery();
  const assigneeID = meQuery.data?.whoami?.claims.sub;
  const { jobs } = useJobListForAssignee(assigneeID);

  const openJobs = jobs.filter(job => !job.closedAt).length;
  if (!openJobs) return null;

  return (
    <div
      className={clsx(
        collapsed ? "absolute right-0 top-0 h-2 w-2 " : "h-4 w-4",
        "align ml-2 flex justify-center rounded-full bg-red-500 text-white",
      )}>
      {!collapsed && (
        <span className="text-center text-2xs" data-testid="open-jobs-notification-sidebar">
          {openJobs}
        </span>
      )}
    </div>
  );
};
